<template>
    <b-card class="mb-3">
        <template v-if="isImage">
            <b-img :src="fileUrl" fluid alt="Image preview" class="border"></b-img>
        </template>

        <template v-else-if="isPDF">
            <b-embed type="iframe" aspect="4by3" :src="fileUrl" class="border"></b-embed>
        </template>

        <template v-else>
            <b-alert variant="warning" show>
                Cannot preview this file type.
            </b-alert>
        </template>
    </b-card>
</template>

<script>
export default {
    name: "AttachmentPreview",
    props: {
        file: {
            type: [File, String],
            required: true,
        },
    },
    computed: {
        fileUrl() {
            return typeof this.file === "string"
                ? this.file
                : URL.createObjectURL(this.file);
        },
        isImage() {
            const type = this.getMimeType();
            return type.startsWith("image/");
        },
        isPDF() {
            const type = this.getMimeType();
            return type === "application/pdf";
        },
    },
    methods: {
        getMimeType() {
            if (typeof this.file === "string") {
                const extension = this.file.split(".").pop().toLowerCase();
                if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension)) {
                    return `image/${extension === "jpg" ? "jpeg" : extension}`;
                }
                if (extension === "pdf") return "application/pdf";
                return "unknown";
            } else {
                return this.file.type || "unknown";
            }
        },
    },
    beforeDestroy() {
        if (typeof this.file !== "string") {
            URL.revokeObjectURL(this.fileUrl);
        }
    },
};
</script>
